type TelemetryMsg = {
  kind: "server-timing";
  level: "info" | "warn" | "error";
  text: string;
  raw?: string | null;
  jsonResult?: unknown;
};

class TelemetryBus {
  private target = new EventTarget();
  publish(msg: TelemetryMsg) {
    this.target.dispatchEvent(new CustomEvent("telemetry", { detail: msg }));
  }
  subscribe(fn: (msg: TelemetryMsg) => void) {
    const handler = (e: Event) => fn((e as CustomEvent).detail);
    this.target.addEventListener("telemetry", handler);
    return () => this.target.removeEventListener("telemetry", handler);
  }
}

export const telemetryBus = new TelemetryBus();
